import React, { useState, useEffect } from "react";

export default function useOnScreen(elem, callback) {
  const [isIntersecting, setIntersecting] = useState(false);
  const [interSectingRatio, setIntersectingRatio] = useState(0);
  useEffect(() => {
    const observer = new IntersectionObserver(([entry]) => {
      setIntersectingRatio(entry.intersectionRatio);
      setIntersecting(entry.isIntersecting);
      if (entry.isIntersecting) {
        callback();
      }
    });
    observer.observe(elem.current);
    return () => {
      observer.disconnect();
    };
  }, []);
  return [isIntersecting, interSectingRatio];
}
